<template>
  <section class="add-user fixed wh100 left0 top0 flex-center">

    <ValidationObserver class="w100" v-slot="{ handleSubmit }">

      <form class="text-left mauto"
            @submit.prevent="handleSubmit(onSubmit)">

        <h2 class="text-center">Aseaza-te la masa {{ masa }}</h2>

        <ValidationProvider rules="required"
                            v-slot="{ errors }"
                            v-for="(item, index) in fields"
                            :key="index">
          <label :for="item"
                 :class="{red: errors[0]}">{{ item }}:</label>
          <input :id="item" type="text"
                 v-model="data[item]"
                 placeholder="nume">
        </ValidationProvider>

        <button class="green-btn">SUBMIT</button>
      </form>

    </ValidationObserver>

  </section>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'add-user',

    data () {
      return {
        data: {
          nume: undefined,
          ceBei: undefined,
          zoom: undefined
        },
        fields: [
          'nume',
          'ceBei',
          'zoom'
        ]
      }
    },

    computed: {
      ...mapState({
        masa: 'masa'
      })
    },

    methods: {
      onSubmit () {
        this.$store.dispatch('create_table', this.data)
      }
    }
  }
</script>

<style lang="less">
  .add-user {
    background-color: rgba(0, 0, 0, .8);

    form {
      width: 90%;
      max-width: 600px;
      padding: 12px 18px 42px;
      background-color: white;
      border-radius: 8px;
    }

    h2 {
      font-size: 2.4rem;
    }

    label {
      display: inline-block;
      font-size: 1.8rem;
      margin-bottom: 8px;
    }

    input {
      margin-bottom: 18px;
    }

    button {
      margin-top: 12px;
    }
  }
</style>
